import { JobApplicationResume } from './jobapplicationresume';

export class CommonUserInfo {

    public userId: number = 0;
    public firstName: string = '';
    public lastName: string = '';
    public email: string = '';
    public countryCode: string = '1';
    public phoneNumber: string = '';
    public mobile: string = '';
    public phoneNumberValid:boolean=false;
    public recruiterName: string = '';
    public recruiterEmail: string = '';
    public resume: JobApplicationResume = new JobApplicationResume();
    public resumeFile: any;
    public additionalNote: string = '';
    public wereYouReferred: boolean = false;

}
